// extracted by mini-css-extract-plugin
export default {"box":"FontPicker_box__hiOxY","title":"FontPicker_title__jjgyo"};